























































































































import Vue from "vue";
export default Vue.extend({
  name: "AiGeneratedAllCompanies",
  components: {},
  data() {
    return {
      selected1: false,
      selected2: false,
      selected3: false
    };
  },
  methods: {
    select(count?: number) {
      if (count == 1) {
        this.selected1 = true;
      } else if (count == 2) {
        this.selected2 = true;
      } else if (count == 3) {
        this.selected3 = true;
      }

      this.$emit("select", count);
    },
    unselect(count?: number) {
      if (count == 1) {
        this.selected1 = false;
      } else if (count == 2) {
        this.selected2 = false;
      } else if (count == 3) {
        this.selected3 = false;
      }
      this.$emit("unselect", count);
    }
  }
});
